import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { UserDetailsPage } from '@/pages/super-admin/user-details';

const userDetailsSearchSchema = z.object({
	page: z.coerce.number().optional(),
	limit: z.coerce.number().optional(),
	companyId: z.coerce.string().optional(),
	dateFrom: z.coerce.string().optional(),
	dateTo: z.coerce.string().optional(),
});

export const Route = createFileRoute('/_authenticated/super-admin/users/$userId')({
	component: UserDetailsPage,
	validateSearch: userDetailsSearchSchema,
});
